import { BASE_URL } from "@/services/api/base";

export const getAcknowledgements = `${BASE_URL}/Helper/GetAcknowledgement`;
